import React, { useEffect, useState } from 'react';
import './RelacionPep.scss';
import { Button, Col, Divider, Form, Icon, Input, Radio, Row, Select, Table } from 'antd';
import useFormItems from '../../../../customHooks/useFormItems';
import { t } from 'i18next';
import { cargosOptions, relationshipOptions, tipoDocOptions } from '../../optList';

export default function RelacionPep({ form, sectionName, apiForm, clientName, format, docValidator, registerData }) {

  const {
    obj,
    rowData,
    handleSaveOnAddRow,
    handleOnChangeTableElement,
    handleCleanRowData,
    toDescriptionsPdf,
    handleDeleteRow,
    handleSaveOnChangeField
  } = useFormItems(apiForm);

  useEffect(() => {
    if (rowData.parentesco === 'Mi Persona') {
      rowData.nombre = registerData.nombre
      rowData.rutRelacionado = registerData.rut
      rowData.tipoDocRelacionada = registerData.tipoDoc === 'Rut' ? 'Chile-Rut' : 'Otros'
      form.setFieldsValue({
        relacionPepNombre: registerData.nombre,
        relacionPepRutRelacionado: registerData.rut,
        relacionPepTipoDoc: registerData.tipoDoc === 'Rut' ? 'Chile-Rut' : 'Otros'
      });
  }
  }, [rowData.parentesco]);

  const records = obj.json?.[sectionName]?.records || []
  
  const fieldsParams = [
    {
      type: 'divider',
      dividerText: 'Datos del Organismo Estatal'
    },
    {  
      type: 'select',
      jsonKeyName: "categoria",
      label: "Categoría",
      id: "relacionPepCategoria",
      options: [{val: 'PEP', text: 'PEP'},{val: 'Funcionario Publico', text: 'Funcionario Público'}]
    },
    {
      type: 'input',
      label: "Institución u Organismo Público",
      jsonKeyName: "nombreInstitucion",
      id: "relacionPepNombreInstitucion", 
    },
    {
      type: 'divider',
      dividerText: `Datos de la persona relacionada a ${rowData["nombreInstitucion"] || ''}`
    },
    {
      type: 'select',
      label: "Parentesco",
      jsonKeyName: "parentesco",
      id: "relacionPepParentesco",
      options: relationshipOptions,
    },
    {
      type: 'input',
      label: "Nombre",
      jsonKeyName: "nombre",
      id: "relacionPepNombre", 
    },
    {
      type: 'select',
      label: "Tipo de documento de identidad",
      jsonKeyName: "tipoDocRelacionada",
      id: "relacionPepTipoDoc", 
      options: tipoDocOptions
    },
    {
      type: 'input',
      label: "Documento de identidad",
      jsonKeyName: "rutRelacionado",
      id: "relacionPepRutRelacionado",
      customValidator: docValidator(form.getFieldValue('relacionPepTipoDoc'))
    },
    {
      type: 'select',
      label: "Cargo",
      jsonKeyName: "cargo",
      id: "relacionPepCargo",
      options: cargosOptions,
    },
    {
      type: 'date',
      label: "Fecha de término",
      jsonKeyName: "firedDate",
      id: "relacionPepFiredDate",
    }
  ]

  const getColumns = () => {
    const columnsArray = fieldsParams.map(field=> {
      return {title: field.label, dataIndex: field.jsonKeyName}
    })
    columnsArray.push(
      {
        title: "Acción",
        dataIndex: "",
        key: "x",
        render: (text, record, index) => (
          <a onClick={() => handleDeleteRow(sectionName, "records", index)}>
            <Icon type="delete" />
          </a>
        ),
      }
    )

    return columnsArray;
  }


  return (
    <div className='generic-form-malla-section'>
      <Row className="subheader" style={{ marginTop: "0px" }}>
        <Col xl={24}>FUNCIONARIOS PUBLICOS O PERSONAS EXPUESTAS POLÍTICAMENTE</Col>
      </Row>
      <Row className="summary">
        <Col xl={21}>
          <p>
            Declaro que mi cónyuge, conviviente civil o pareja es funcionario (a) público (a), o que tengo parentesco hasta el segundo grado de consanguinidad o afinidad con funcionarios (as) públicos (as), tanto en la administración central del Estado como en instituciones o empresas fiscales o semifiscales, municipales, autónomas u organismos creados por el Estado o bajo su dependencia.
          </p>
          <p>
            Asimismo, declaro que mi cónyuge, conviviente civil o pareja es Persona Expuesta Políticamente (PEP), o que tengo parentesco hasta el segundo grado de consanguinidad o afinidad con personas que detenten tal calidad.
          </p>
        </Col>
        <Col span={2} push={1}>
          <Form.Item>
            {form.getFieldDecorator("hasPep", {
              rules: [
                {required: true, message: t("messages.aml.dontForgetSelect")},
                { 
                  validator: (rule, value, callback) => {
                    if (value === true && records.length === 0) {
                      callback(true);
                    } else {
                      callback(); // Pasar la validación
                    }
                  }
                }
              ],
              initialValue: apiForm?.json?.relacionPep?.hasPep 
            })(
              <Radio.Group
                onChange={({ target }) =>
                  handleSaveOnChangeField(form, target.value, sectionName, "hasPep", "hasPep")
                }
              >
                <Radio className="radio-switch" value={true}>
                  Sí
                </Radio>
                <Radio className="radio-switch" value={false}>
                  No
                </Radio>
              </Radio.Group>
            )}
          </Form.Item>
        </Col>
      </Row>
      {obj.json.relacionPep?.hasPep && (
        <>
        { format === 'html' &&
        <>
          <Row gutter={[20, 20]}>
            {fieldsParams.map(item => (
              <>
                {item.type === 'divider' &&
                  <Divider orientation={item.orientation ?? 'left'}>
                    {item?.dividerText ?? ''}
                  </Divider>
                }
                {(item.type === 'input' || item.type === 'select' || item.type === 'radio') &&
                  <Col span={8} key={item.id}>
                    <Form.Item label={item.label}>
                      {form.getFieldDecorator(item.id, {
                        rules: [
                          { validator: item.customValidator },
                          { required: true, message: t("messages.aml.requiredData") }
                        ],
                      })(
                        <div>
                          {item.type === 'input' && (
                            <Input
                              onChange={(e) => handleOnChangeTableElement(e.target.value, item.jsonKeyName)}
                              value={rowData[item.jsonKeyName] ?? ""}
                            />
                          )}
                          
                          {item.type === 'select' && (
                            <Select
                              allowClear
                              onChange={(value) => {
                                handleOnChangeTableElement(value, item.jsonKeyName);
                                form.setFieldsValue({ [item.id]: value });
                              }}
                              style={{ width: '100%' }}
                              value={rowData[item.jsonKeyName] ?? ""}
                            >
                              {item.options.map(option => (
                                <Select.Option value={option.val} key={option.key}>{option.text}</Select.Option>
                              ))}
                            </Select>
                          )}
                        </div>
                      )}
                    </Form.Item>
                  </Col>
                }
              </>
            ))}
          </Row>
          <Row className="button-row">
            {records.length === 0 &&
              <Col span={24} style={{ color: 'red' }} className="missing-registers ant-form-explain">
                {t("messages.aml.registersRequired")}
              </Col>
            }
            <Col className="addRelation" xl={3}>
              <Button type="primary" htmlType="button" onClick={() => {
                handleSaveOnAddRow(sectionName, "records", form, fieldsParams);
              }} icon="plus"> Añadir </Button>
            </Col>
            <Col className="addRelation" xl={3}>
              <Button type="primary" htmlType="button" icon="delete" onClick={() => handleCleanRowData(sectionName, form)}> Limpiar </Button>
            </Col>
          </Row>
        </>
        }
          <Row>
            {records.length > 0 && format === 'html' ?
              <Table columns={getColumns()} dataSource={records} size="middle" pagination={false}/>
              :
              toDescriptionsPdf(sectionName, fieldsParams)
            }
          </Row>
        </>
      )}
    </div>
  );
}
